// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_C5zMP {
  font-family: unset;
  background: #f1efee;
  color: #68615e;
  max-width: 800px;
  padding: 2px 8px;
}

.editor_C5zMP > div:focus {
  outline: none;
}

.editorContainer_UJ3PC {
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/expression-editor/lib/ExpressionEditor.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd","sourcesContent":[".editor {\n  font-family: unset;\n  background: #f1efee;\n  color: #68615e;\n  max-width: 800px;\n  padding: 2px 8px;\n}\n\n.editor > div:focus {\n  outline: none;\n}\n\n.editorContainer {\n  padding: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_C5zMP`,
	"editorContainer": `editorContainer_UJ3PC`
};
export default ___CSS_LOADER_EXPORT___;
